<template>
  <div class="distance" v-if="distance">
    <h3>Route information</h3>
    <ul class="distance-values">
      <li><b>Distance:</b> {{ distance.total_distance }}</li>
      <li><b>Route time (without trafic):</b> {{ distance?.traffic }}</li>
      <li><b>Route time (with trafic):</b> {{ distance?.traffic_free }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useDistanceStore } from "../store/distance.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const estimateStore = useNewEstimateStore();
const distanceStore = useDistanceStore();
const distance = computed(() => distanceStore.distance);

watch(
  () => [
    estimateStore.estimate.shippingZip,
    estimateStore.estimate.installation,
  ],
  ([zip, installation]) => {
    if (typeof zip !== "string" || zip.length < 5) {
      distanceStore.distance = null;
      return;
    }
    distanceStore.fetchDistance(zip, installation);
  },
  { immediate: true, deep: true },
);
</script>

<style scoped lang="scss">
.distance {
  position: absolute;
  bottom: 8%;

  padding-top: 20px;

  h3 {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    color: #404d63;

    margin-bottom: 12px;
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }
}
.distance-values {
  display: flex;
  flex-direction: column;
  gap: 10px;

  font-size: 14px;
  color: #404d63;
}
</style>
